/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface HistoricalBookRequest {
  /**
   * Base pair ID.
   */
  pairId: number;
  /**
   * Timestamp.
   */
  timestamp: string;
  /**
   * Commission rate. 1 = 0.001%
   */
  commissionRate: number;
}
